import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconCheck from "../../../assets/images/icon-check.svg"

const CheckBox = styled.div`
    /* height: 52px; */
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    /* padding: 0px 16px; */
    color: #505050;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.43px;
    text-align: left;
    cursor: pointer;

    &.active {
        color: #25368D;
    }

    &.disable {
        cursor: default;
    }

    .box {
        width: 16px;
        height: 16px;
        min-width: 16px;
        margin-left: 1px;
        margin-right: 12px;
        border-radius: 2px;
        border: 1px solid #505050;

        &.active {
            background-color:  #FBE250;
            border: 1px solid #FBE250;
        }
    }

    .main-box {
        width: calc(100% - 32px);
        min-height: 46px;
        padding: 4px 16px;
    }
`;

const TextAreaBox = styled.textarea`
    width: calc(100% - 48px);
    resize: none;
    padding: 8px;
    margin: 0px 16px 8px 16px;
    border-radius: 8px;
    border: 1px solid #FBE250;
    color: #25368D;
    font-size: 16px;
    font-weight: 400;
`;

function CheckComponent({
    list,
    value,
    disable,
    labelError,
    isError,
    onSelect,
}) {
    const [selectValue, setSelectValue] = useState(null)

    useEffect(() => {
        setSelectValue(value)
    }, [value])

    function onCheckActive(param) {
        const model = selectValue?.find(x => x.value === param?.value);
        return model ? true : false;
    }
    function onCheckDescriptionActive(param) {
        const model = selectValue?.find(x => x.value === param?.value);
        return model?.description ? true : false;
    }
    function onSetValueDescription(param) {
        const model = selectValue?.find(x => x.value === param?.value);
        return model ? selectValue.descriptionValue : ""
    }

    function handleSelect(param) {
        if (disable) return;
        let list = [];
        if (Array.isArray(selectValue)) {
            list = JSON.parse(JSON.stringify(selectValue))
        }
        const index = list.findIndex(x => x.value === param?.value);
        if (index >= 0) {
            list.splice(index, 1);
        } else {
            list.push(param);
        }
        setSelectValue(list)
        onSelect && onSelect(list);
    }
    function handleInput(event, param) {
        const _value = event.target.value;
        if (disable) return;
        let detail = [...selectValue]
        const index = detail.findIndex(x => x.value === param.value);
        if (index >= 0) {
            detail[index].descriptionValue = _value;
        }
        setSelectValue(detail)
        onSelect && onSelect(detail);
    }

    return (
        <div>
            {list?.map((_value, index) => {
                return (
                    <CheckBox key={index} className={`${onCheckActive(_value) ? "active" : ""} ${disable ? "disable" : ""}`}>
                        <div className="vertical-center main-box" onClick={() => handleSelect(_value)}>
                            <div className={`content-center box ${onCheckActive(_value) ? "active" : ""}`}>
                                {onCheckActive(_value) && <img alt="img" src={IconCheck} />}
                            </div>
                            {_value.label || _value.value || ""}
                        </div>
                        {onCheckDescriptionActive(_value) &&
                            <TextAreaBox
                                rows={4}
                                placeholder="กรุณาระบุ"
                                value={onSetValueDescription(_value)}
                                disabled={disable}
                                onInput={(e) => handleInput(e, _value)}
                            />
                        }
                    </CheckBox>
                )
            })}
        </div>
    )
}

export default CheckComponent;